import React from 'react';
import { useP } from '../i18n/useP';
import '../styles/designSystem.css';

/* Compteur de filtres — ferme la zone 5 du standard de carte. Il ne paraît que
   si au moins un filtre est actif : un « 0 filtre » permanent serait du bruit,
   et un « Effacer » sans rien à effacer, un faux bouton. La croix est en
   terracotta : elle DÉFAIT, c'est le seul emploi de cette couleur dans une
   card (2026-08-27). */
export default function FilterCount({ count = 0, onClear }) {
  const p = useP();
  if (!count) return null;
  return (
    <span className="lk-filtercount">
      {count} {count > 1 ? p('filtres') : p('filtre')}
      <button type="button" className="lk-filtercount__clear" onClick={onClear}
              title={p('Effacer les filtres')} aria-label={p('Effacer les filtres')}>✕</button>
    </span>
  );
}
